<template>
  <div class="inner-box">
    <div class="content-name">
      <h2 class="dp-ib">{{ title }}</h2>
      <div class="btn-wrap btn-type1 clearfix">
        <button class="btn-size btn-blue fl_left" @click="goSearch">
          <span class="btn-icon"><i class="fas fa-pen-alt"></i></span> 조회
        </button>
        <button class="btn-size btn-gray fl_left" @click="popDetail">
          <span class="btn-icon"><i class="far fa-file"></i></span> 추가
        </button>
      </div>
    </div>

    <!-- 검색조건 영역 -->
    <div class="desc-content search-border">
      <div class="item desc-left">
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">핸드폰번호</span>
          </div>
          <div class="desc" style="width: 70%">
            <input
              class="input Rt-M tal"
              type="text"
              v-model="form.blackMobile"
              @keypress.enter.prevent="goSearch"
              maxlength="13"
              placeholder="010-1234-5678"
            />
          </div>
        </div>
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">방문회사</span>
          </div>
          <div class="desc" style="width: 70%">
            <b-select class="select is-fullwidth" v-model="form.visitCompCd">
              <option value="">==전체==</option>
              <option value="100010">일진전기</option>
              <option value="100002">일진홀딩스</option>
              <option value="101301">일진다이아</option>
              <option value="222300">알피니언메디칼</option>
            </b-select>
          </div>
        </div>
      </div>
      <div class="item desc-center">
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">이름</span>
          </div>
          <div class="desc" style="width: 70%">
            <input
              class="input Rt-M tal"
              type="text"
              v-model="form.blackNm"
              @keypress.enter.prevent="goSearch"
            />
          </div>
        </div>
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">사용여부</span>
          </div>
          <div class="desc" style="width: 70%">
            <b-select class="select is-fullwidth" v-model="form.useYn">
              <option value="">==전체==</option>
              <option value="Y">사용</option>
              <option value="N">미사용</option>
            </b-select>
          </div>
        </div>
      </div>
      <div class="item desc-right">
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">회사명</span>
          </div>
          <div class="desc" style="width: 70%">
            <input
              class="input Rt-M tal"
              type="text"
              v-model="form.blackCompNm"
              @keypress.enter.prevent="goSearch"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- //검색조건 영역 -->

    <!-- 테이블 -->
    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="table-name">
            <h3 class="ico_table_name">블랙리스트 목록</h3>
          </div>
          <div class="btn-wrap btn-type1 clearfix">
            <button class="btn-size btn-excel" @click="saveExcel">엑셀 저장</button>
          </div>
        </div>
        <div class="grid-wrap">
          <dhx-grid
            ref="grid"
            v-model="blackList"
            :config="config"
            @constructGridSuccessful="constructGridSuccessful"
          />
        </div>
      </div>
    </div>
    <!-- //테이블 -->
  </div>
</template>

<script>
import mixin from "@/mixin";
import mixinSlip from "@/mixin/slip";
import DhxGrid from "@/components/DhxGrid.vue";
import DhxCalendar from "@/components/DhxCalendar.vue";
import BlackDetail from "@/views/BlackDetail.vue";
import BlackDetailMg from "@/views/BlackDetailMg.vue";
import _ from "lodash";

export default {
  name: "blackListMg",
  mixins: [mixin, mixinSlip],
  components: { DhxGrid, DhxCalendar, BlackDetail, BlackDetailMg },
  data() {
    return {
      config: {
        columns: [
          {
            id: "rn",
            type: "cntr",
            align: "center",
            sort: "na",
            value: "No.",
            width: 35,
          },
          {
            id: "compCd",
            type: "ro",
            align: "center",
            sort: "na",
            value: "방문회사코드",
            width: 80,
            hide: true,
          },
          {
            id: "compNm",
            type: "ro",
            align: "center",
            sort: "na",
            value: "방문회사",
            width: 80,
          },
          {
            id: "blackMobile",
            type: "ro",
            align: "center",
            sort: "na",
            value: "전화번호",
            width: 80,
          },
          {
            id: "blackNm",
            type: "ro",
            align: "center",
            sort: "na",
            value: "이름",
            width: 80,
          },
          {
            id: "blackBirth",
            type: "ro",
            align: "center",
            sort: "na",
            value: "생년월일",
            width: 80,
          },
          {
            id: "blackCompNm",
            type: "ro",
            align: "center",
            sort: "na",
            value: "회사명",
            width: 80,
          },
          {
            id: "remark",
            type: "ro",
            align: "left",
            sort: "na",
            value: "내용",
            width: 400,
          },
          {
            id: "useYn",
            type: "ro",
            align: "center",
            sort: "na",
            value: "사용여부",
            width: 50,
          },
          {
            id: "regDtm",
            type: "ro",
            align: "center",
            sort: "na",
            value: "등록일",
            width: 50,
          },
          {
            id: "regId",
            type: "ro",
            align: "center",
            sort: "na",
            value: "작성자",
            width: 100,
            hide: true,
          },
        ],
        height: 570,
        enablePaging: true,
        pagingSize: 12,
        afterRefreshData(grid, data) {
          this.$nextTick(() => {
            _.forEach(data, (item, index) => {
              let rId = index + 1;
              grid
                .cells(rId, 5)
                .setValue(
                  this.$moment(grid.cells(rId, 5).getValue()).format("YYYY-MM-DD")
                );
              grid
                .cells(rId, 9)
                .setValue(
                  this.$moment(grid.cells(rId, 9).getValue()).format("YYYY-MM-DD")
                );
            });
          });
        },
      },
      title: "블랙리스트 관리",
      blackList: [],
      form: {
        compCd: "",
        blackMobile: "",
        blackNm: "",
        blackCompNm: "",
        useYn: "",
        visitCompCd: "",
      },
    };
  },
  methods: {
    constructGridSuccessful(grid) {
      grid.attachEvent("onRowDblClicked", (rId) => {
        let vm = this;
        let mobileNo = grid.cells(rId, 3).getValue();
        let compCd = grid.cells(rId, 1).getValue();
        this.$modal.open({
          component: BlackDetailMg,
          props: {
            compCd: compCd,
            mobileNo: mobileNo,
            isNew: false,
          },
          parent: this,
          width: 800,
        });
      });
    },
    getCompCdCombo() {
      this.$http
        .get(`/api/code/combo`, { params: { groupCd: "COMP_CD" } })
        .then((response) => {
          this.compCds = response.data;
        });
    },
    saveExcel() {
      this.downloadExcel(this.$refs.grid);
    },
    goSearch() {
      this.$store.commit("loading");
      const param = JSON.parse(JSON.stringify(this.form));
      const stripFields = ["blackMobile"];
      _.forEach(stripFields, (name) => (param[name] = this.toPure(param[name])));

      this.$http
        .post(`/api/visit/black/mgList`, param)
        .then((response) => {
          if (response.data) {
            let data = response.data;
            //핸드폰 번호 유형으로 변환
            let regExp = /(01[016789])([0-9]{1}[0-9]{2,3})([0-9]{4})$/;
            let myArray;
            for (let i = 0; i < data.length; i++) {
              myArray = regExp.exec(data[i].blackMobile);
              data[i].blackMobile = myArray[1] + "-" + myArray[2] + "-" + myArray[3];
            }

            this.blackList = data;
          }
        })
        .finally(() => {
          this.$store.commit("finish");
        });
    },
    popDetail() {
      this.$modal.open({
        component: BlackDetailMg,
        props: {
          isNew: true,
        },
        parent: this,
        width: 800,
      });
    },
  },
  mounted() {
    this.getCompCdCombo();
    this.goSearch();
  },
  watch: {
    "form.blackMobile": {
      immediate: true,
      deep: true,
      handler(value) {
        let val = value.replace(/-/g, "").replace(/[^0-9]/g, "");
        let len = val.length;
        if (len == 11) {
          this.form.blackMobile = val.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        } else if (len == 8) {
          this.form.blackMobile = val.replace(/(\d{4})(\d{4})/, "$1-$2");
        } else if (len == 9) {
          this.form.blackMobile = val.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
        } else {
          if (val.indexOf("02") == 0) {
            this.form.blackMobile = val.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
          } else {
            this.form.blackMobile = val.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
          }
        }
      },
    },
  },
};
</script>

<style scoped>
.desc-content:after {
  clear: both;
  content: "";
  display: block;
}

.btn-wrap {
  margin-bottom: 10px;
}

.desc-content {
  border: 2px solid #9db6c9;
  background: #f9fafc;
  margin: 0 0 20px 0;
  border-radius: 4px;
  padding: 15px 2%;
  clear: both;
}

.desc-content .item {
  float: left;
}

.desc-content .item .desc-item {
  position: relative;
  padding-left: 82px;
  margin-bottom: 8px;
}

.desc-content .item .desc-item:last-child {
  margin-bottom: 0;
  height: 25px;
}

.desc-content .item .desc-item .tit {
  position: absolute;
  left: 0;
}

.desc-content .item .desc-item .label-tit {
  font-family: "NotoM";
  color: #222;
  font-size: 15px;
}

.desc-content .item.desc-left .desc-item {
  padding-left: 90px;
}

.desc-content .item.desc-left .desc-item .desc:after {
  clear: both;
  content: "";
  display: block;
}

.desc-content .item.desc-left .desc-item .td-s-thumb.search-area input {
  float: left;
}

.desc-content .item.desc-left .desc-item .desc.select select {
  width: 70%;
}

.desc-content .item.desc-left {
  width: 35%;
  padding-right: 40px;
}

.desc-content .item.desc-center {
  width: 35%;
  padding-right: 40px;
}

.desc-content .item.desc-right {
  width: 30%;
}

.search-area input {
  position: relative;
}

.search-border .td-s-thumb.search-area > input,
.search-border
  .td-s-thumb.search-area
  > .ip-box
  .search-border
  .td-s-thumb.search-area
  > button {
  float: left;
}
</style>
